import React from "react";
import useMetaTags from "../../hooks/useMetaTags"; // Adjust path based on your project structure

const PostPregnancyPeriodCare = () => {
  useMetaTags({
    title: "Post-Pregnancy Period Care | Organic Pads for Gentle Recovery",
    description: "Ensure a smooth postpartum recovery with organic menstrual pads. Experience extra-gentle, chemical-free, and highly absorbent period care designed for new moms.",
    keywords: "postpartum period care, post-pregnancy pads, organic maternity pads, gentle recovery pads, best pads for new moms, chemical-free menstrual care",
    author: "Organic Pads",
    robots: "index, follow",
    canonical: "/post-pregnancy-period-care",
    ogTitle: "Post-Pregnancy Period Care | Organic Pads for Gentle Recovery",
    ogDescription: "Organic pads provide extra-gentle and chemical-free protection for postpartum recovery. Find the best natural care for your sensitive healing phase.",
    ogImage: "https://images.unsplash.com/photo-1584714268709-c3dd9c92b378?w=600",
    ogUrl: "https://organicpads.shop/post-pregnancy-period-care",
    ogType: "article",
    twitterCard: "summary_large_image",
    twitterTitle: "Post-Pregnancy Period Care | Organic Pads for Gentle Recovery",
    twitterDescription: "Ensure a comfortable postpartum recovery with extra-absorbent, chemical-free organic pads. Discover the best natural protection for new moms.",
    twitterImage: "https://images.unsplash.com/photo-1584714268709-c3dd9c92b378?w=600",
    twitterSite: "@OrganicPads",
    twitterCreator: "@OrganicPads",
  });

  const schemaMarkup = {
    "@context": "https://schema.org",
    "@type": "Article",
    "mainEntityOfPage": {
      "@type": "WebPage",
      "@id": "/post-pregnancy-period-care"
    },
    "headline": "Post-Pregnancy Period Care | Organic Pads for Gentle Recovery",
    "description": "Ensure a smooth postpartum recovery with organic menstrual pads. Experience extra-gentle, chemical-free, and highly absorbent period care designed for new moms.",
    "image": "https://images.unsplash.com/photo-1584714268709-c3dd9c92b378?w=600",
    "author": {
      "@type": "Organization",
      "name": "Organic Pads",
      "url": "/"
    },
    "publisher": {
      "@type": "Organization",
      "name": "Organic Pads",
      "logo": {
        "@type": "ImageObject",
        "url": "/logo.png"
      }
    },
    "datePublished": "2025-02-24",
    "dateModified": "2025-02-24",
    "keywords": [
      "postpartum period care",
      "post-pregnancy pads",
      "organic maternity pads",
      "gentle recovery pads",
      "best pads for new moms",
      "chemical-free menstrual care"
    ]
  }
  
  return (
    <>
    <div className="max-w-4xl mx-auto p-6 text-gray-800">
      <h1 className="text-3xl font-bold text-center mb-6">Post-Pregnancy Period Care: Why Organic Matters More Than Ever</h1>
      <img
        src="https://images.unsplash.com/photo-1584714268709-c3dd9c92b378?w=600"
        alt="Postpartum Care"
        className="w-full rounded-lg mb-6"
      />
      <p>
        The postpartum period brings unique challenges, and choosing the right menstrual products becomes crucial. Organic pads offer gentle, chemical-free protection for your body during this sensitive recovery phase.
      </p>
      
      <h2 className="text-2xl font-semibold mt-6">Postpartum Benefits</h2>
      <ul className="list-disc list-inside mt-2">
        <li>Extra gentle on healing tissues</li>
        <li>Chemical-free recovery support</li>
        <li>Enhanced absorption for heavy flow</li>
        <li>Reduced irritation risk</li>
        <li>Natural comfort during healing</li>
      </ul>
      
      <h2 className="text-2xl font-semibold mt-6">How to Care for Postpartum Needs?</h2>
      <p>
        Select <strong>extra-absorbent</strong> organic pads specifically designed for postpartum flow and recovery.
      </p>
      
      <img
        src="https://plus.unsplash.com/premium-photo-1702598576513-fe7425ebf6bd?w=600"
        alt="Recovery Care"
        className="w-full rounded-lg mt-6"
      />
      
      <h2 className="text-2xl font-semibold mt-6">Final Thoughts</h2>
      <p>
        Support your postpartum journey naturally. <strong>Choose organic for gentle recovery!</strong>
      </p>
    </div>
    
      {/* Schema Markup */}
      <script type="application/ld+json">
        {JSON.stringify(schemaMarkup)}
      </script>
    </>
  );
};

export default PostPregnancyPeriodCare;
